export enum CompanyType {
	FishCompany = 'Depositor',
	Warehouse = 'stock',
}
